import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Heart, MessageCircle } from 'lucide-react';
import './InstagramFeed.css';

const InstagramFeed = () => {
    const posts = [
        { id: 1, img: '/insta1.png', likes: 124, comments: 12 },
        { id: 2, img: '/insta2.png', likes: 89, comments: 5 },
        { id: 3, img: '/insta3.png', likes: 256, comments: 28 },
        { id: 4, img: '/insta4.png', likes: 112, comments: 9 },
    ];

    return (
        <section className="insta-section">
            <div className="container">
                <div className="insta-header">
                    <div className="flex items-center justify-center gap-3 mb-4">
                        <Instagram className="text-primary" size={32} />
                        <h2 className="text-4xl font-black italic">Suivez-nous</h2>
                    </div>
                    <p className="text-gray-500">Rejoignez la communauté Sugar Hut sur Instagram</p>
                    <a
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary font-bold hover:underline"
                    >
                        @sugar_hut_montesson
                    </a>
                </div>

                <div className="insta-grid">
                    {posts.map((post, idx) => (
                        <motion.div
                            key={post.id}
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: idx * 0.1 }}
                            className="insta-post group"
                        >
                            <img src={post.img} alt={`Sugar Hut Post ${post.id}`} className="insta-img" />
                            <div className="insta-overlay">
                                <div className="flex gap-6 text-white font-bold">
                                    <div className="flex items-center gap-2">
                                        <Heart size={20} fill="white" /> {post.likes}
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <MessageCircle size={20} fill="white" /> {post.comments}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default InstagramFeed;
